module.exports = __webpack_public_path__ + "img/reading3.2e09291e.png";